import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'form-form',
  name: '动态表单',
  icon: '表',
  group: '表单组件',
  description: '按表单编码渲染已发布表单，承接填写与提交。',
  defaultProps: {
    formCode: '',
    bizType: '',
    bizId: ''
}
}
